import { render, staticRenderFns } from "./AvatarListModal.vue?vue&type=template&id=59a265de&scoped=true"
import script from "./AvatarListModal.vue?vue&type=script&lang=js"
export * from "./AvatarListModal.vue?vue&type=script&lang=js"
import style0 from "./AvatarListModal.vue?vue&type=style&index=0&id=59a265de&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59a265de",
  null
  
)

export default component.exports